export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./InfoWidgetsOteador.vue?vue&type=template&id=e4890042&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/Oteador/InfoWidgetsOteador.vue?vue&type=template&id=e4890042&scoped=true
// module id = D/eG
// module chunks = 41